import { render, staticRenderFns } from "./StaffProfile.vue?vue&type=template&id=ad9f790a&"
import script from "./StaffProfile.vue?vue&type=script&lang=js&"
export * from "./StaffProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports